<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-row mb-3">
                <div class="form-group col-lg-3">
                    <label for="element">{{ $t('omsz-form.labels.product') }}</label>
                    <multiselect
                        id="element"
                        v-model="element"
                        track-by="value"
                        label="name"
                        :placeholder="$t('omsz-form.placeholders.select')"
                        :selectLabel="$t('omsz-form.placeholders.select_enter')"
                        :selectedLabel="$t('omsz-form.placeholders.selected')"
                        :deselect-label="$t('omsz-form.placeholders.remove')"
                        :options="elements"
                        :allow-empty="false"
                        :searchable="false"
                        :disabled="isDisabled"
                        :class="{'is-invalid': !isValid.elementValid}"
                        @select="selectType">
                        <template slot="noResult">{{ $t('omsz-form.errors.not_found') }}</template>
                    </multiselect>
                </div>
                <div class="form-group buttons ml-auto d-flex align-items-end">
                    <button id="send" class="btn btn-primary" type="submit" :disabled="!element || isLoading">
                        <span>{{ $t('omsz.buttons.start_query') }}</span>
                        <i class="icon icon-arrow-right"></i>
                    </button>
                </div>
            </div>
        </form>

        <span v-show="isLoading">{{ $t('omsz.placeholders.please_wait') }}</span>
        <div v-if="errorMessage">{{ errorMessage }}</div>
         <air-pollution v-if="airPollutionData" :air-pollution-data="airPollutionData"/>
        <div v-if="response && !errorMessage" class="vue-img-container"></div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import AirPollution from '../airPollutionPages/AirPollution';

export default {
    name: 'aod',
    components: {
        Multiselect,
        AirPollution,
    },
    
    props: {
        elements: {
            type: Array,
        },
        defaultelement: {
            type: Object,
            default: '',
        },
        defaultimageurl: {
            type: String,
            default: '',
        },
        defaults: {
            type: Object,
            default: '',
        },
    },
    data() {
        return {
            element: null,
            form: {
                    element: null,
                },
            isValid: {
                elementValid: true,
            },
            isLoading: false,
            isDisabled: false,
            errorMessage: '',
            response: null,
            airPollutionData: null,
        }
    },
    created() {
       if (this.defaults.value !== '') {
            this.element = this.elements.find(option => option.value === this.defaults.value);
        }
        this.submit();
    },
    methods: {
        selectType(e) {
            this.isValid.elementValid = true;
            this.form.element =  e.value;
        },
        async submit(e) {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            this.errorMessage = null;
            this.airPollutionData = null;

            axios.post('/api/modelling/aod', {
                element: this.element.value,
            }).then(({ data }) => {
                this.airPollutionData = Object.assign(data, { element: this.element });
            }).catch(error => {
                this.errorMessage = this.$t('omsz-form.errors.no_result');
            }).finally(() => {
                this.isLoading = false;
            });
        }
    }
}

</script>